<template>
  <div class="fiche-entreprise">
    <va-modal
      class="modal"
      v-model="showModal"
      cancelText="Annuler"
      okText="Enregistrer"
      max-width="100%"
      v-on:ok="updateSalarie"
      v-on:cancel="closeModal"
      hideDefaultActions
      noEscDismiss
      noOutsideDismiss
      disabled
    >
      <div class="specialwidth">
        <div class="row row-inside">
          <div class="flex md4">
            <span style="color: blue"><b>Modifier collaborateur</b></span>
          </div>
        </div>
        <va-separator />
        <div class="row row-inside">
          <div class="flex md4 padded-input">
            <va-select
              label="Titre"
              v-model="titre"
              :options="titreOptions"
              no-clear
            />
          </div>
          <div class="flex md4 padded-input">
            <va-input
              v-model="nom"
              placeholder="-"
              label="Nom"
            />
          </div>
          <div class="flex md4 padded-input">
            <va-input
              v-model="prenom"
              placeholder="-"
              label="Prénom"
            />
          </div>
        </div>
        <div class="row row-inside">
          <div class="flex md4 padded-input">
            <editable-date-picker
              label="Date de naissance"
              :config="{ dateFormat: 'd-m-Y' }"
              v-model="birthdate"
              @input-raw="birthdateRawInput = $event"
            />
          </div>
          <div class="flex md4 padded-input">
            <va-input
              v-model="telephone"
              placeholder="-"
              label="Téléphone"
            />
          </div>
          <div class="flex md4 padded-input">
            <va-input
              v-model="email"
              placeholder="-"
              label="Courriel"
            />
          </div>
        </div>
        <va-separator />
        <div class="row row-inside">
          <div class="flex md12">
            <b>Historique d'emploi</b>
          </div>
          <div class="flex md12">
            <va-data-table
              class="va-table--hoverable va-table--stripped"
              :fields="fieldsEmplois"
              :data="emplois"
              no-data-label="Aucun historique d'emploi"
              :per-page="5"
            >
              <template
                slot="actions"
                slot-scope="props"
              >
                <va-button
                  class="ma-0"
                  small
                  icon="fa fa-pencil"
                  @click="editEmploi(props.rowData)"
                />
              </template>
            </va-data-table>
          </div>
        </div>
        <va-separator />
        <div class="row row-inside">
          <div class="flex md12">
            <b>{{ emploiForm.idemploi ? "Modifier un emploi" : "Ajouter un emploi" }}</b>
          </div>
          <div class="flex md4 padded-input">
            <va-select
              label="Entreprise"
              v-model="emploiForm.entreprise"
              key-by="identreprise"
              text-by="nom"
              :options="listeEntreprise"
              searchable
            />
          </div>
          <div class="flex md4 padded-input">
            <va-select
              label="Poste"
              v-model="emploiForm.poste"
              key-by="idformation_emploi_poste"
              text-by="nom"
              :options="posteOptions"
              no-clear
            />
          </div>
          <div class="flex md4 padded-input">
            <va-select
              label="Contrat"
              v-model="emploiForm.contrat"
              key-by="idformation_emploi_contrat"
              text-by="nom"
              :options="contratOption"
              no-clear
            />
          </div>
          <div class="flex md4 padded-input">
            <va-select
              label="Statut"
              v-model="emploiForm.statut"
              key-by="idformation_emploi_status"
              text-by="nom"
              :options="statutOption"
              no-clear
            />
          </div>
          <div class="flex md4 padded-input">
            <editable-date-picker
              label="Date de début"
              :config="{ dateFormat: 'd-m-Y' }"
              v-model="emploiForm.dateStart"
              @input-raw="emploiStartRawInput = $event"
            />
          </div>
          <div class="flex md4 padded-input">
            <editable-date-picker
              label="Date de fin"
              :config="{ dateFormat: 'd-m-Y' }"
              v-model="emploiForm.dateEnd"
              @input-raw="emploiEndRawInput = $event"
            />
          </div>
          <div class="flex md12 padded-input">
            <va-button color="gray" flat @click="resetEmploiForm">Réinitialiser</va-button>
            <va-button @click="saveEmploi">
              {{ emploiForm.idemploi ? "Mettre à jour" : "Créer" }}
            </va-button>
          </div>
        </div>
      </div>
      <template v-slot:actions>
        <div class="va-modal__actions mb-3">
          <va-button color="gray" flat @click="closeModal">Annuler</va-button>
          <va-button @click="updateSalarie">Enregistrer</va-button>
        </div>
      </template>
    </va-modal>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import EditableDatePicker from "./EditableDatePicker.vue";

export default {
  name: "update-salarie",
  components: {
    "editable-date-picker": EditableDatePicker,
  },
  props: ["value", "salarie"],
  data() {
    return {
      showModal: false,
      titre: "",
      nom: "",
      prenom: "",
      email: "",
      telephone: "",
      birthdate: "",
      birthdateRawInput: "",
      titreOptions: ["MONSIEUR", "MADAME"],
      emplois: [],
      listeEntreprise: [],
      emploiForm: {
        idemploi: null,
        entreprise: {},
        poste: {},
        contrat: {},
        statut: {},
        dateStart: "",
        dateEnd: "",
      },
      emploiStartRawInput: "",
      emploiEndRawInput: "",
      contratOption: [
        { idformation_emploi_contrat: 1, nom: "CDI" },
        { idformation_emploi_contrat: 2, nom: "CDD" },
        { idformation_emploi_contrat: 3, nom: "Intérim" },
		{ idformation_emploi_contrat: 4, nom: "" },
      ],
      statutOption: [
        { idformation_emploi_status: 1, nom: "Dirigeant-ti" },
        { idformation_emploi_status: 2, nom: "Salarié" },
        { idformation_emploi_status: 3, nom: "Dirigeant salarié" },
      ],
      posteOptions: [
        { idformation_emploi_poste: 1, nom: "Directeur" },
        { idformation_emploi_poste: 2, nom: "Employé de marée" },
        { idformation_emploi_poste: 3, nom: "Collaborateur" },
      ],
    };
  },
  methods: {
    closeModal() {
      this.$emit("input", false);
    },
    loadSalarie() {
      const salarie = this.salarie || {};
      this.titre = salarie.titre || "";
      this.nom = salarie.nom || "";
      this.prenom = salarie.prenom || "";
      this.email = salarie.email || salarie.courriel || "";
      this.telephone = salarie.telephone || "";

      if (salarie.birthdate) {
        const formatted = moment(salarie.birthdate).format("DD-MM-YYYY");
        this.birthdate = formatted;
        this.birthdateRawInput = formatted;
      } else {
        this.birthdate = "";
        this.birthdateRawInput = "";
      }
    },
    async updateSalarie() {
      const titre = (this.titre || "").toString().trim();
      const nom = (this.nom || "").toString().trim();
      const prenom = (this.prenom || "").toString().trim();
      const birthdateRaw = (this.birthdateRawInput || "").toString().trim();

      if (!titre) {
        this.launchToast("Le titre est obligatoire");
        return;
      } else if (!nom) {
        this.launchToast("Le nom est obligatoire");
        return;
      } else if (!prenom) {
        this.launchToast("Le prénom est obligatoire");
        return;
      }

      let birthdateParsed = null;
      if (birthdateRaw) {
        birthdateParsed = moment(birthdateRaw, ["DD-MM-YYYY", "DD/MM/YYYY"], true);
        if (!birthdateParsed.isValid()) {
          this.launchToast("La date de naissance doit être au format JJ-MM-AAAA ou JJ/MM/AAAA");
          return;
        }
      }

      const salarie = this.salarie || {};
	  console.log('test',salarie);
      const idemploye = salarie.idemploye ||
        null;

      try {
        const payload = {
          idemploye: idemploye,
          titre: titre,
          nom: nom,
          prenom: prenom,
          telephone: this.telephone,
          email: this.email,
          birthdate: birthdateParsed ? birthdateParsed.format("YYYY-MM-DD") : null,
        };
        const response = await axios.put("/api/afpf/update-salarie", payload);
        this.$emit("updated", response.data || payload);
        this.closeModal();
      } catch (error) {
        console.log(error);
        this.launchToast("Erreur lors de la modification du collaborateur");
      }
    },
    async getEmploymentHistory() {
		
      const salarie = this.salarie || {};
      const idemploye =
        salarie.idemploye ||
        null;
      if (!idemploye) {
        this.emplois = [];
        return;
      }
      try {
        const response = await axios.get("/api/afpf/emploi-historique", {
          params: { idemploye: idemploye },
        });
        const data = response.data && response.data.data ? response.data.data : response.data;
        this.emplois = Array.isArray(data) ? data : [];
      } catch (error) {
        console.log(error);
        this.launchToast("Erreur lors du chargement de l'historique d'emploi");
      }
    },
    async getListEntreprises() {
      try {
        const response = await axios.get("/api/retours/liste-entreprises");
        this.listeEntreprise = (response.data.listeEntreprise || []).filter(Boolean);
      } catch (error) {
        console.log(error);
        this.launchToast("Erreur lors du chargement des entreprises");
      }
    },
    resetEmploiForm() {
      this.emploiForm = {
        idemploi: null,
        entreprise: {},
        poste: {},
        contrat: {},
        statut: {},
        dateStart: "",
        dateEnd: "",
      };
      this.emploiStartRawInput = "";
      this.emploiEndRawInput = "";
    },
    editEmploi(emploi) {
      this.emploiForm.idemploi = emploi.idemploi || emploi.id_emploi || null;
      this.emploiForm.entreprise = this.listeEntreprise.find(
        (ent) => ent && ent.identreprise == emploi.identreprise
      ) || {};
      this.emploiForm.poste = this.posteOptions.find(
        (poste) => poste.idformation_emploi_poste == emploi.idposte
      ) || {};
      this.emploiForm.contrat = this.contratOption.find(
        (contrat) => contrat.idformation_emploi_contrat == emploi.idcontrat
      ) || {};
      this.emploiForm.statut = this.statutOption.find(
        (statut) => statut.idformation_emploi_status == emploi.idstatut
      ) || {};

      const start = emploi.date_start || emploi.dateStart;
      const end = emploi.date_end || emploi.dateEnd;
      this.emploiForm.dateStart = start ? moment(start).format("DD-MM-YYYY") : "";
      this.emploiForm.dateEnd = end ? moment(end).format("DD-MM-YYYY") : "";
      this.emploiStartRawInput = this.emploiForm.dateStart;
      this.emploiEndRawInput = this.emploiForm.dateEnd;
    },
    async saveEmploi() {
      const salarie = this.salarie || {};
      const idemploye =
        salarie.idemploye ||
        null;
      if (!idemploye) {
        this.launchToast("Collaborateur introuvable");
        return;
      }

      if (!this.emploiForm.entreprise || !this.emploiForm.entreprise.identreprise) {
        this.launchToast("L'entreprise est obligatoire");
        return;
      }
      if (!this.emploiForm.poste || !this.emploiForm.poste.idformation_emploi_poste) {
        this.launchToast("Le poste est obligatoire");
        return;
      }
      if (!this.emploiForm.contrat || !this.emploiForm.contrat.idformation_emploi_contrat) {
        this.launchToast("Le contrat est obligatoire");
        return;
      }
      if (!this.emploiForm.statut || !this.emploiForm.statut.idformation_emploi_status) {
        this.launchToast("Le statut est obligatoire");
        return;
      }
      const startRaw = (this.emploiStartRawInput || "").toString().trim();
      if (!startRaw) {
        this.launchToast("La date de début est obligatoire");
        return;
      }
      const startParsed = moment(startRaw, ["DD-MM-YYYY", "DD/MM/YYYY"], true);
      if (!startParsed.isValid()) {
        this.launchToast("La date de début doit être au format JJ-MM-AAAA ou JJ/MM/AAAA");
        return;
      }
      let endParsed = null;
      const endRaw = (this.emploiEndRawInput || "").toString().trim();
      if (endRaw) {
        endParsed = moment(endRaw, ["DD-MM-YYYY", "DD/MM/YYYY"], true);
        if (!endParsed.isValid()) {
          this.launchToast("La date de fin doit être au format JJ-MM-AAAA ou JJ/MM/AAAA");
          return;
        }
      }

      const payload = {
        identreprise: this.emploiForm.entreprise.identreprise,
        idstatut: this.emploiForm.statut.idformation_emploi_status,
        idcontrat: this.emploiForm.contrat.idformation_emploi_contrat,
        idposte: this.emploiForm.poste.idformation_emploi_poste,
        date_start: startParsed.format("YYYY-MM-DD"),
        date_end: endParsed ? endParsed.format("YYYY-MM-DD") : null,
      };

      try {
        if (this.emploiForm.idemploi) {
          await axios.put("/api/afpf/update-emploi", {
            idemploi: this.emploiForm.idemploi,
            ...payload,
          });
          this.launchToast("Emploi mis à jour");
        } else {
          await axios.post("/api/afpf/creation-emploi", {
            idemploye: idemploye,
            ...payload,
          });
          this.launchToast("Emploi créé");
        }
        await this.getEmploymentHistory();
        this.resetEmploiForm();
      } catch (error) {
        console.log(error);
        this.launchToast("Erreur lors de l'enregistrement de l'emploi");
      }
    },
    launchToast(toast) {
      this.showToast(toast, {
        position: "bottom-center",
        duration: 5000,
      });
    },
  },
  mounted() {
    this.showModal = this.value;
    this.loadSalarie();
    this.getListEntreprises();
    this.getEmploymentHistory();
  },
  watch: {
    value() {
      this.showModal = this.value;
      if (this.value) {
		console.log("watch value", this.salarie);
        this.loadSalarie();
        this.getListEntreprises();
        this.getEmploymentHistory();
      }
    },
    salarie: {
      handler() {
        if (this.showModal) {
          this.loadSalarie();
          this.getEmploymentHistory();
        }
      },
      deep: true,
    },
  },
  computed: {
    fieldsEmplois() {
      return [
        {
          name: "entreprise_nom",
          title: "Entreprise",
          width: "30%",
        },
        {
          name: "statut",
          title: "Statut",
          width: "15%",
        },
        {
          name: "date_start",
          title: "Début",
          width: "15%",
        },
        {
          name: "date_end",
          title: "Fin",
          width: "15%",
        },
        {
          name: "__slot:actions",
          title: "Actions",
          width: "10%",
        },
      ];
    },
  },
};
</script>

<style>
.specialwidth {
  width: 40vw;
  overflow: auto;
}
.padded-input {
  padding: 0.5rem;
}
</style>
